import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import axios from "@/api/axios";
import { getItem } from "@/helpers/persistanceStorage";
import UUID from "vue-uuid";

require("@/assets/css/styles.css");

Vue.config.productionTip = false;

Vue.use(UUID);

const moment = require("moment");
require("moment/locale/ru");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.prototype.$http = axios;
const token = getItem("accessToken");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] =
    process.env.VUE_APP_AUTHPREFIX + " " + token;
}

Vue.mixin({
  methods: {
    can: (key) =>
      store.getters.currentUser
        ? store.getters.currentUser.roles.includes(key)
        : false,
  },
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
